export interface CommercialOffer {
  commercial_offer_id: string;
  max_amount: number;
  min_amount: number;
  opening_fee_fix_amount: number;
  opening_fee_percentage: number;
  opening_fee_type: string;
  term: number;
  tin: number;
}

export interface CommercialOfferInfo {
  currency: string;
  flow: string;
  commercialOfferId: string;
}

export interface CommercialOffersListRequest {
  currency: string;
  flow: string;
}

export interface CommercialOffersListResponse {
  commercial_offers: CommercialOffer[];
}

export enum FlowType {
  CBR = 'CBR',
  CEX = 'CEX',
  CHP = 'CHP',
  ECO = 'ECO',
  SUS = 'SUS',
}

export interface CommercialOffersFlowsListRequest {
  currency: string;
  flows: FlowType[];
}

export interface CommercialOfferFlow {
  flow: FlowType;
  commercial_offers: CommercialOffer[];
}

export interface CommercialOffersFlowsListResponse {
  flow_commercial_offers: CommercialOfferFlow[];
}
